import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';

/** Syncs server theme preference after login / session restore. */
const ThemeAuthSync: React.FC = () => {
  const { user } = useAuth();
  const { syncThemeFromUser } = useTheme();

  useEffect(() => {
    if (user?.preferences?.theme) {
      syncThemeFromUser(user.preferences.theme);
    }
  }, [user?.id, user?.preferences?.theme, syncThemeFromUser]);

  return null;
};

export default ThemeAuthSync;
